import React, { useEffect, useState, useRef } from 'react';
import Links from '../HomeNavigationTile/Links/Links';
import { isMobile } from 'react-device-detect';
import './main-menu.css'
import componentDisplayExtension from '../../commonUtils/ComponentDisplayExtension';

const MainMenu = (props) => {

    const [links, setLinks] = useState([])

    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    const [showSubMenu, setShowSubMenu] = useState({
        visible: false
    })

    const showMenuHandler = (e) => {
        if (e.target.id === 'mainlink') {
            showSubMenu.visible ?
                setShowSubMenu({ ...showSubMenu, visible: false }) :
                setShowSubMenu({ ...showSubMenu, visible: true })
        }
        e.preventDefault()
    }

    useEffect(() => {
        if (props.fields.items) {
            setLinks(props.fields.items)
        }
    }, [])

    /**
       * Hook that alerts clicks outside of the passed ref
       */
    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setShowSubMenu({ ...showSubMenu, visible: false })
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    let diapCss = {}
    if(isMobile){
        if (window.location.pathname === '/diaper-calculator') {
            diapCss = {
                top: '26px',
                paddingTop: '15px'
            }
        }
        else if(window.location.pathname === '/recipe-finder'){
            diapCss = {
                top: '0',
                // paddingTop: '15px'
            }
        }
        else {
            diapCss = {
                top: '0px',
                // paddingTop: '15px'
            }
        }
    }
    
    if(!isMobile){
        if(window.location.pathname === '/diaper-calculator'){
            diapCss = {
                top: '15px',
                // paddingTop: '15px'
            }
        }
        else if(window.location.pathname === '/recipe-finder' || window.location.pathname === '/en/recipe-finder'){
            diapCss = {
                top: '25px',
                // paddingTop: '15px'
            }
        }
        else {
            diapCss = {
                top: '5px',
                // paddingTop: '15px'
            }
        }
    }
    
    //IFRAME: Code to check displaying based on querystring
    if (!componentDisplayExtension.isDisplay(props)) {
        return (<></>)
    }
    //---------------------------------------------

    return (
        <div className="container-quicklinks">
            <div className="container">
                <div className="quicklinks">
                    <nav ref={wrapperRef} >
                        <a href="" className='parentlink test'>
                            <i className="fa fa-bars" aria-hidden="true" id="mainlink" onClick={(event) => showMenuHandler(event)}></i>
                        </a>
                        {showSubMenu.visible &&
                            <div className="sublinks">
                                {
                                    links.map((link) => <Links linkdetails={link.fields.links} />)
                                }
                            </div>
                        }
                    </nav>
                </div>
            </div>
        </div>
    )
};

export default MainMenu;
